function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M255.1 255.2V0L148.8 56.7v127.6h-14.2v-56.7h-28.3V92.1H77.9v35.4H28.3v127.6H0v28.3h283.5v-28.3l-28.4.1zm-148.8-71H85v70.9H56.7v-99.2h49.6v28.3zm70.9-110.5l49.6-26.5V85h-28.3v14.2h28.3v14.2h-28.3v14.2h28.3v14.2h-28.3V156h28.3v99.2h-28.3v-70.9h-21.3V73.7zm-63.8 181.5v-42.5h56.7v42.5h-56.7zM77.9 42.5H44.5L56.7 0 0 70.9h33.4l-12.1 42.5 56.6-70.9z"
})));